
export const GROWTHBOOK_FEATURES_KEYS = {
    SHOW_ZARA_BASKET_NAV: "cart.nav.is-zara-basket-tab-enabled",
    SHOW_ZARA_FAVORITES_NAV: "cart.nav.is-favorite-tab-enabled",
    IS_NEW_FLOW_ENABLED: "checkout.address.is-new-flow-enabled",
    COOKIES_CONSENT_ENABLED_APPS: "cookies.consent.is-cookies-consent-enabled-apps",
    PREOWNED_TAB_LAST: "cart.nav.preowned-tab-last",
}

export const GROWTHBOOK_TARGET_VARIANTS = {
    ANDROID: "android",
    IOS: "ios",
    WEB_DESKTOP: "web_desktop",
    WEB_MOBILE: "web_mobile"
}